// extracted by mini-css-extract-plugin
export default {"lds-spinner":"lds-spinner--GOI5yZsVSV","ldsSpinner":"lds-spinner--GOI5yZsVSV"};